const color = (product) =>
  product.options?.find((option) => option.name === "Color")?.values[0];

const isLightColor = (product) =>
  ["white"].includes((color(product) || "").toLowerCase());

const price = (product) => product.priceRange?.minVariantPrice?.amount;

const compareAtPrice = (product) =>
  product.compareAtPriceRange?.minVariantPrice?.amount;

const currency = (product) =>
  product.priceRange?.minVariantPrice?.currencyCode;

// Pre-order products in a Purple Dot product family aren't always published
// to the online store yet, so fall back to building the URL from the handle.
const url = (product) =>
  product.onlineStoreUrl
    ? new URL(product.onlineStoreUrl).pathname
    : `/products/${product.handle}`;

export default function addProductHelpers(product) {
  product.helpers = {
    color: color(product),
    isLightColor: isLightColor(product),
    price: price(product),
    compareAtPrice: compareAtPrice(product),
    currency: currency(product),
    url: url(product),
  };

  return product;
}
